import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ROOT_PATH, ROUTES_ACCESSIBLE_WITHOUT_SESSION, ROUTES_TO_REDIRECT_WHEN_SESSION } from "@constants/page";
import { EditionTypeEnum } from "@crusher-shared/types/common/general";
import { getBoolean } from "@utils/common";
import { getEdition } from "@utils/helpers";
import { isTempTestPending } from "@utils/user";
import { resolvePathToBackendURI } from "./common/url";
export var handleOpenSourceMounting = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, router, loadCallback) {
    var user, pathname, _user$meta;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            user = data.userData;
            pathname = router.pathname;

            if (!(getEdition() === EditionTypeEnum.OPEN_SOURCE)) {
              _context.next = 17;
              break;
            }

            if (getBoolean(user === null || user === void 0 ? void 0 : (_user$meta = user.meta) === null || _user$meta === void 0 ? void 0 : _user$meta.INITIAL_ONBOARDING)) {
              _context.next = 8;
              break;
            }

            _context.next = 6;
            return router.push("/setup/onboarding");

          case 6:
            _context.next = 16;
            break;

          case 8:
            if (!ROUTES_TO_REDIRECT_WHEN_SESSION.includes(pathname)) {
              _context.next = 16;
              break;
            }

            if (!isTempTestPending()) {
              _context.next = 14;
              break;
            }

            _context.next = 12;
            return router.push("/app/tests");

          case 12:
            _context.next = 16;
            break;

          case 14:
            _context.next = 16;
            return router.push("/app/dashboard");

          case 16:
            loadCallback();

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleOpenSourceMounting(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/*
	Move to src_ee
 */

export var handleEERouting = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, router, loadCallback) {
    var user, isUserLoggedIn, pathname;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            user = data.userData, isUserLoggedIn = data.isUserLoggedIn;
            pathname = router.pathname;

            if (!isUserLoggedIn) {
              _context2.next = 19;
              break;
            }

            console.log("Starting", ROUTES_ACCESSIBLE_WITHOUT_SESSION, pathname);

            if (!(!getBoolean(user.meta.INITIAL_ONBOARDING) && !["/login_sucessful"].includes(pathname))) {
              _context2.next = 9;
              break;
            }

            _context2.next = 7;
            return router.push("/setup/onboarding");

          case 7:
            _context2.next = 17;
            break;

          case 9:
            if (!ROUTES_TO_REDIRECT_WHEN_SESSION.includes(pathname)) {
              _context2.next = 17;
              break;
            }

            if (!isTempTestPending()) {
              _context2.next = 15;
              break;
            }

            _context2.next = 13;
            return router.push("/app/tests");

          case 13:
            _context2.next = 17;
            break;

          case 15:
            _context2.next = 17;
            return router.push("/app/dashboard");

          case 17:
            _context2.next = 22;
            break;

          case 19:
            if (!(!ROUTES_ACCESSIBLE_WITHOUT_SESSION.includes(pathname) || pathname === ROOT_PATH)) {
              _context2.next = 22;
              break;
            }

            _context2.next = 22;
            return router.push("/login");

          case 22:
            if (loadCallback) {
              loadCallback();
            }

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function handleEERouting(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
/*
	@Note :-
	Can remove passing router as dependency. More clean and easier to create test.
	loadCallback, router dependecy can be removed.
 */

export var redirectUserOnMount = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, router, loadCallback) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(getEdition() === EditionTypeEnum.OPEN_SOURCE)) {
              _context3.next = 5;
              break;
            }

            _context3.next = 3;
            return handleOpenSourceMounting(data, router, loadCallback);

          case 3:
            _context3.next = 7;
            break;

          case 5:
            _context3.next = 7;
            return handleEERouting(data, router, loadCallback);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function redirectUserOnMount(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}(); // query: Router Query object

export var getGoogleAuthUrl = function getGoogleAuthUrl(query) {
  var inviteType = query.inviteType,
      inviteCode = query.inviteCode;
  var finalURL = new URL(resolvePathToBackendURI("/users/actions/auth.google"));

  if (inviteType && inviteCode) {
    finalURL.searchParams.append("inviteType", inviteType);
    finalURL.searchParams.append("inviteCode", inviteCode);
  }

  return finalURL.toString();
};